import React from 'react';
interface IState {
	permissions: PermissionDTO[];
}
const initialState: IState = {
	permissions: [] as PermissionDTO[],
};

const PermissionContext = React.createContext(initialState);
export default PermissionContext;